import { ReactNode } from "react";

export const Stat = ({
  label,
  value,
  className = ""
}: {
  label: ReactNode;
  value: string | number | ReactNode;
  className?: string;
}) => {
  return (
    <div className={`flex flex-col justify-center ${className}`}>
      <h3 className="mb-2 min-h-6 text-sm font-normal text-content-400 whitespace-nowrap flex items-center">
        {label}
      </h3>
      {
        // if value is react node, render it directly
        typeof value === "string" || typeof value === "number" ? (
          <p className="text-sm text-content-1000 font-medium truncate">
            {value}
          </p>
        ) : (
          value
        )
      }
    </div>
  );
};
